module.exports = __webpack_public_path__ + "img/Réalisation portail et clôture bicoloration.b7e61320.jpg";